import type { ReactNode } from 'react'
import { Label } from '@/components/ui/label'

interface Props {
  label: string
  htmlFor?: string
  help?: string
  error?: string
  children: ReactNode
}

// Labelled field with plain-language guidance and an optional error, used to
// explain what to write in each step of the guided process form.
export default function FieldGroup({ label, htmlFor, help, error, children }: Props) {
  return (
    <div className="grid gap-2">
      <Label htmlFor={htmlFor}>{label}</Label>
      {help && <p className="text-sm text-muted-foreground">{help}</p>}
      {children}
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  )
}
